module.exports = __webpack_public_path__ + "static/media/login_app.a4a74b07.png";